// The app icon's badge in the app (mobile/ios BossChatBadgePlugin): the WebView has no Badging API. Android draws its dot from the
// notifications themselves, which the app clears when read, so only iOS has the plugin; elsewhere this does nothing.

interface BossChatBadgePlugin {
  set(options: { count: number }): Promise<void>
}

type SetBadge = (count: number) => Promise<void>

// A function, never the plugin proxy: an async function resolving with the proxy would call BossChatBadge.then().
let loaded: SetBadge | null = null
async function setter(): Promise<SetBadge> {
  if (!loaded) {
    const { registerPlugin } = await import('@capacitor/core')
    const plugin = registerPlugin<BossChatBadgePlugin>('BossChatBadge')
    loaded = (count) => plugin.set({ count })
  }
  return loaded
}

/** Test seam. */
export function setBadgeSetter(set: SetBadge | null): void {
  loaded = set
}

/** Sets the app icon's badge to the unread total (0 clears it). Best effort: never throws. */
export async function setNativeBadge(count: number): Promise<void> {
  try {
    await (await setter())(Math.max(0, Math.floor(count)))
  } catch {
    // An older app without the plugin, or Android.
  }
}
